import { render } from "./SurveyHeader.vue?vue&type=template&id=04a656ab"
import script from "./SurveyHeader.vue?vue&type=script&lang=js"
export * from "./SurveyHeader.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3444732531/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__